(function() {
  'use strict';

  window.KS_AB = {
    getVariant: function(testName, variants) {
      if (!variants || !variants.length) variants = ['a', 'b'];
      var key = 'ks_ab_' + testName;
      var stored = localStorage.getItem(key);
      if (stored && variants.indexOf(stored) > -1) return stored;
      var variant = variants[Math.floor(Math.random() * variants.length)];
      localStorage.setItem(key, variant);
      return variant;
    },

    apply: function(testName, variants) {
      var variant = this.getVariant(testName, variants);
      document.querySelectorAll('[data-ab-test="' + testName + '"]').forEach(function(el) {
        if (el.dataset.abVariant === variant) {
          el.style.removeProperty('display');
          el.removeAttribute('hidden');
        } else {
          el.style.display = 'none';
          el.setAttribute('hidden', '');
        }
      });
      // Push to dataLayer for analytics
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'ab_test_impression', test_name: testName, variant: variant });
      return variant;
    },

    track: function(testName, action) {
      var variant = this.getVariant(testName);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'ab_test_conversion', test_name: testName, variant: variant, action: action });
    },

    init: function(tests) {
      if (!tests) return;
      var self = this;
      Object.keys(tests).forEach(function(name) {
        if (tests[name].active !== false) {
          self.apply(name, tests[name].variants);
        }
      });
    }
  };
})();
